import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import useRequest from "../../../context/useRequest";
import { useLocation } from 'react-router-dom';

const CouponForm = ({ setPromoCodeApplied }) => {
    const location = useLocation();
    const { vehicleDetails } = location.state;
    const [isCoupon, setIsisCoupon] = useState("");
    const [error, setError] = useState(null);
    const { data: applyCode, sendRequest } = useRequest();

    useEffect(() => {
        if (applyCode && Object.keys(applyCode).length > 0) {
            // Only update coupon state with promo code string
            setIsisCoupon(applyCode.promocode);
        }
    }, [applyCode]);

    const couponHandler = (e) => {
        setIsisCoupon(e.target.value);
    }

    const couponSubmitHandler = async (e) => {
        e.preventDefault();

        const applyCodeData = new FormData();
        applyCodeData.append("promocode", isCoupon);
        applyCodeData.append("base_fare", vehicleDetails.base_fare);
        applyCodeData.append("tax_fare", vehicleDetails.taxes_and_charges);

        try {
            const response = await sendRequest({
                method: "POST",
                url: "/applyPromocode",
                body: applyCodeData,
            });

            if (response?.status && response.status == true) {
                if (response?.data) {
                    setPromoCodeApplied({
                        'status': true,
                        'promocode': response.data?.promocode,
                        'discount': response.data?.discount_amount
                    })
                }
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <>
            <form onSubmit={couponSubmitHandler} className="confirm-section--payment-makeCoupons-cabHotDeals-form mt-4">
                <div className="form-group confirm-section--payment-makeCoupons-cabHotDeals-form-input ">
                    <Input
                        type="text"
                        name="coupon"
                        placeholder="eg. CAB100"
                        value={isCoupon}
                        onChange={couponHandler}
                        className="form-control"
                        label="Enter Coupon code "
                    />
                </div>

                <div className="form-group confirm-section--payment-makeCoupons-cabHotDeals-form-submit">
                    <button type="submit" className="apply">APPLY</button>
                </div>
            </form>
            {error && <div className="error-message">{error}</div>}
        </>
    );
};

export default CouponForm;
